import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Slider
} from "@vapor/react-material";
import ExtendedTypography from "@vapor/react-extended/ExtendedTypography";
import { useTranslation } from "react-i18next";

export const RischioSectionC = ({
  tenantTypeId,
  sliderVal,
  isUserAllowedToManage,
  onSliderChange,
  sliderLivelli,
  sliderLivelliAvv,
  subTotaleC,
}) => {
  const { t } = useTranslation();

  return (
    <TableContainer component={Paper} sx={{ mt: 2 }}>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell align="left" width="70%">
              <ExtendedTypography
                variant="subtitle2"
                fontStyle={{ fontWeight: "bold" }}
              >
                {t("valutazione.form.tabellaC.titolo")}
              </ExtendedTypography>
            </TableCell>
            <TableCell align="center" width="15%">
              <ExtendedTypography
                variant="subtitle2"
                fontStyle={{ fontWeight: "bold" }}
              >
                {t("valutazione.form.fattoreRischioRiscontrato")}
              </ExtendedTypography>
            </TableCell>
            <TableCell align="center" width="15%">
              <ExtendedTypography
                variant="subtitle2"
                fontStyle={{ fontWeight: "bold" }}
              >
                {t("valutazione.form.livelloRischioSpecifico")}
              </ExtendedTypography>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell colSpan={2}>
              <ExtendedTypography
                variant="subtitle2"
                fontStyle={
                  tenantTypeId === 1 || tenantTypeId === 3
                    ? { fontWeight: "bold" }
                    : null
                }
              >
                {t("valutazione.form.tabellaC.c1")}
              </ExtendedTypography>
            </TableCell>
            <TableCell align="center" colSpan={1}>
              <Slider
                id="sliderC1"
                name="sliderC1"
                step={1}
                marks={tenantTypeId === 3 ? sliderLivelliAvv : sliderLivelli}
                min={1}
                max={tenantTypeId === 3 ? 5 : 4}
                valueLabelDisplay="auto"
                value={sliderVal.sliderC1}
                onChange={onSliderChange}
                disabled={!isUserAllowedToManage}
              />
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell colSpan={2}>
              <ExtendedTypography
                variant="subtitle2"
                fontStyle={
                  tenantTypeId === 1 || tenantTypeId === 3
                    ? { fontWeight: "bold" }
                    : null
                }
              >
                {t("valutazione.form.tabellaC.c2")}
              </ExtendedTypography>
            </TableCell>
            <TableCell align="center" colSpan={1}>
              <Slider
                id="sliderC2"
                name="sliderC2"
                step={1}
                marks={tenantTypeId === 3 ? sliderLivelliAvv : sliderLivelli}
                min={1}
                max={tenantTypeId === 3 ? 5 : 4}
                valueLabelDisplay="auto"
                value={sliderVal.sliderC2}
                onChange={onSliderChange}
                disabled={!isUserAllowedToManage}
              />
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell colSpan={2}>
              <ExtendedTypography
                variant="subtitle2"
                fontStyle={
                  tenantTypeId === 1 || tenantTypeId === 3
                    ? { fontWeight: "bold" }
                    : null
                }
              >
                {t("valutazione.form.tabellaB.c3")}
              </ExtendedTypography>
            </TableCell>
            <TableCell align="center" colSpan={1}>
              <Slider
                id="sliderC3"
                name="sliderC3"
                step={1}
                marks={tenantTypeId === 3 ? sliderLivelliAvv : sliderLivelli}
                min={1}
                max={tenantTypeId === 3 ? 5 : 4}
                valueLabelDisplay="auto"
                value={sliderVal.sliderC3}
                onChange={onSliderChange}
                disabled={!isUserAllowedToManage}
              />
            </TableCell>
          </TableRow>

          {/* Subtotal Row */}
          <TableRow sx={{ backgroundColor: "hsl(199, 100%, 40%)" }}>
            <TableCell colSpan="2" align="right" width="85%">
              <ExtendedTypography
                variant="subtitle2"
                fontStyle={{
                  fontWeight: "bold",
                  color: "white",
                }}
              >
                {t("rischio.rischioForm.cstGeoRsk")}
              </ExtendedTypography>
            </TableCell>
            <TableCell align="center" width="15%">
              <ExtendedTypography
                variant="subtitle2"
                fontStyle={{
                  fontWeight: "bold",
                  color: "white",
                }}
              >
                {subTotaleC}
              </ExtendedTypography>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};
